(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ActivateEmail', ActivateEmail);

  ActivateEmail.$inject = ['$resource', 'API_URI'];

  function ActivateEmail($resource, API_URI) {
    return $resource(API_URI + 'api/activateEmail', {}, {
      'get': {method: 'GET', params: {}, isArray: false}
    });
  }
})();
